/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryViewModel } from './categoryViewModel';
import { ElementsViewModel } from './elementsViewModel';
import { InspectionViewModel } from './inspectionViewModel';
import { LocationProjectViewModel } from './locationProjectViewModel';
import { MasterViewModel } from './masterViewModel';
import { PunchCustomFieldViewModel } from './punchCustomFieldViewModel';
import { PunchMediaViewModel } from './punchMediaViewModel';
import { PunchStageViewModel } from './punchStageViewModel';
import { StatusViewModel } from './statusViewModel';
import { SubcontractorViewModel } from './subcontractorViewModel';
import { TagsViewModel } from './tagsViewModel';
import { UserInfoViewModel } from './userInfoViewModel';

export interface PunchDetailMainViewModel { 
    id?: number;
    code?: string;
    description?: string;
    pdfPositionX?: number;
    pdfPositionY?: number;
    location?: string;
    status?: StatusViewModel;
    discipline?: MasterViewModel;
    punchTags?: Array<TagsViewModel>;
    category?: CategoryViewModel;
    priority?: MasterViewModel;
    departmentAction?: MasterViewModel;
    topic?: MasterViewModel;
    originator?: MasterViewModel;
    subContractor?: SubcontractorViewModel;
    userOriginator?: UserInfoViewModel;
    userValid?: boolean;
    commentary?: string;
    contractorResponsibleName?: string;
    createdAt?: Date;
    punchFields?: Array<PunchCustomFieldViewModel>;
    punchCustomFields?: Array<PunchCustomFieldViewModel>;
    punchItems?: Array<ElementsViewModel>;
    punchStage?: Array<PunchStageViewModel>;
    inspection?: InspectionViewModel;
    entryType?: MasterViewModel;
    coverAndAudioMedia?: Array<PunchMediaViewModel>;
    isRejectable?: boolean;
    isSignable?: boolean;
    onDispute?: boolean;
    closed?: boolean;
    locationProject?: LocationProjectViewModel;
    expectedClosingDate?: Date;
}